// extracted by mini-css-extract-plugin
module.exports = {"fix-version-item":"FixVersionItem_fix-version-item__1JcYQ","selected":"FixVersionItem_selected__12mt5"};